import React from 'react'
import banner_weeding from "../images/cloth_banner.jpg"
import banner from "../images/banner new.jpg";
import banner_main from "../images/banner_garments.jpg";
import diwali from "../images/Wedding slider.jpg";


function Slider() {
  return (
    <div>
      <div id="carouselExampleDark" className="carousel carousel-dark slide" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="3" aria-label="Slide 4"></button>

        </div>
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="10000">
            <div className='fashionbethua'>
              <img src={diwali} className="d-block w-100" alt="diwali_shopping at Siddheswari bastralaya"/>
            </div>

          </div>
          <div className="carousel-item" data-bs-interval="2000">
            <div className='fashionbethua'>
              <img src={banner_weeding} className="d-block w-100" alt="Best Garments showroom in Bethuadahari, Nadia" />
            </div>

          </div>
          <div className="carousel-item" data-bs-interval="2000">
            <div className='fashionbethua'>
              <img src={banner} className="d-block w-100" alt="Best Garments showroom in Bethuadahari, West Bengal" />
            </div>

          </div>

          <div className="carousel-item">
            <div className='fashionbethua'>
              <img src={banner_main} className="d-block w-100" alt="Siddeswari Bastralaya" />
            </div>

          </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  )
}

export default Slider